import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Hidden,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import SearchIcon from '@material-ui/icons/Search';
import SettingsIcon from '@material-ui/icons/Settings';
import CallMadeIcon from '@material-ui/icons/CallMade';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockIcon from '@material-ui/icons/Lock';
import BlockIcon from '@material-ui/icons/Block';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import { format, isValid } from 'date-fns';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { useHistory } from 'react-router-dom';
import {
  emptyObject,
  formattedDateTime,
  formattedCurrency,
  formattedDateTimeIso,
  isEqualObject,
} from '../../../utils/utils';
import useApi from '../../../utils/useApi';
import StoreContext from '../../Store/context';
import UIButtonSearch from '../../UI/Button/Search/Search';
import UIModalFilter from '../../UI/ModalFilter/UIModalFilter';
import UIContainer from '../../UI/Container/UIContainer';
import UIFormTitle from '../../UI/Form/Title/UIFormTitle';
import UIFilter from '../../UI/Button/Filter/UIFilter';
import UIDialogConfirm from '../../UI/Dialog/Confirm/UIDialogConfirm';
import UIDialogTitle from '../../UI/Dialog/Title/UIDialogTitle';
import FormInputDate from '../../UI/Form/InputDate/FormInputDate';
import GreenSwitch from '../../UI/Form/Switch/GreenSwitch';
import FormInputDateTime from '../../UI/Form/InputDateTime/FormInputDateTime';
import useStyles from '../../../utils/useStyle';
import UITablePagination from '../../UI/Table/Pagination/UITablePagination';
import AdministrativeAdjustmentModal from '../../UI/Modal/AdministrativeAdjustment/AdministrativeAdjustmentModal';

import './cashierSearch.css';

const initialState = {
  id: '',
  name: '',
  startDate: null,
  dueDate: null,
  initialValue: 0.0,
  currentValue: 0,
  isOpen: false,
  isActive: false,
  userId: '',
  showCloseAll: false,
};

const initialClick = {
  mouseX: null,
  mouseY: null,
};

const CashierSearch = () => {
  const { credencials, setCredencials, setModalCashierOpen } =
    useContext(StoreContext);
  const history = useHistory();
  const { disabledTextField } = useStyles();

  // verificar se é mobile
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  // modal para encerrar vigencia e abrir/desativar caixa
  const [closeCashier, setCloseCashier] = useState(false);

  // mensagem de confirmação para operações
  const [alert, setAlert] = useState(false);

  // modais de pesquisa e filtragem
  const [view, setView] = useState(false);
  const [filter, setFilter] = useState(false);

  // salvar valores para modalde visualizar/alterar
  const [modalValues, setModalValues] = useState({});

  // modal de ajuste administrativo
  const [adjustModal, setAdjustModal] = useState(false);

  // salvar valores do form de pesquisa
  const [search, setSearch] = useState({ isActive: 1 });
  // verificar se é ativo ou nao na "chavinha"
  const [isActive, setIsActive] = useState(false);

  // paginação
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const humanAttributes = (values) => {
    const valuesTreated = {
      ...values,
      isOpen: Number(values.isOpen) === 1,
      isActive: Number(values.isActive) === 1,
      value: values.currentValue,
      dueDate: isValid(formattedDateTimeIso(values.dueDate))
        ? formattedDateTimeIso(values.dueDate)
        : null,
      startDate: formattedDateTimeIso(values.startDate),
    };
    setModalValues(valuesTreated);
  };

  // provider do click do lado direito
  const [clickRight, setClickRight] = useState(initialClick);
  const handleClickRight = (event, values) => {
    event.preventDefault();
    humanAttributes(values);
    setClickRight({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };
  const handleCloseClickRight = () => {
    setClickRight(initialClick);
  };

  // ação para click esquerdo
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClickLeft = (event, values) => {
    humanAttributes(values);
    setAnchorEl(event.currentTarget);
  };

  const handleCloseClickLeft = () => {
    setAnchorEl(null);
  };

  const [filterLoad, filterInfo] = useApi({
    debounceDelay: 500,
    method: 'get',
    url: '/cash-registers',
  });

  const [terminatesLoad, terminatesInfo, setTerminatesInfo] = useApi({
    method: 'delete',
    url: '/cash-registers',
    onCompleted: (response) => {
      if (response) {
        filterLoad({
          params: search,
        });
      }
    },
  });

  const [updateLoad, updateInfo, setUpdateInfo] = useApi({
    method: 'put',
    url: '/cash-registers',
    onCompleted: (response) => {
      if (response) {
        filterLoad({
          params: search,
        });
      }
    },
  });

  const [adjustLoad, adjustInfo, setAdjustInfo] = useApi({
    method: 'post',
    url: '/cash-registers/adjust',
    onCompleted: (response) => {
      if (response) {
        filterLoad({
          params: search,
        });
      }
    },
  });

  const [usersLoad, usersInfo] = useApi({
    method: 'get',
    params: { isActive: '1' },
    url: '/users',
  });

  useEffect(() => {
    usersLoad();
    filterLoad({
      params: { isActive: 1 },
    });
  }, []);

  function handleModalFilter() {
    setFilter(!filter);
  }

  function handleModalUpdate(values, isClick) {
    if (values) {
      humanAttributes(values);
    }
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setView(!view);
  }

  function handleModalTerminates(values, isClick) {
    if (values) {
      setModalValues(values);
    }
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setCloseCashier(!closeCashier);
  }

  function handleModalAdjust(values, isClick) {
    if (values) {
      humanAttributes(values);
    }
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setAdjustModal(!adjustModal);
  }

  function closeAlert(event, reason) {
    setUpdateInfo();
    setTerminatesInfo();
    setAdjustInfo();
    if (reason === 'clickaway') {
      return;
    }
    setAlert(false);
  }

  function onSubmit(values) {
    const searchValues = {
      ...values,
      isOpen: values.isOpen && 1,
      isActive: (values.showCloseAll && '0') || (!isActive && 1),
      dueDate: isValid(values.dueDate)
        ? format(new Date(values.dueDate), 'yyyy-MM-dd')
        : '',
      startDate: isValid(values.startDate)
        ? format(new Date(values.startDate), 'yyyy-MM-dd')
        : '',
      userId: values.userId && Number(credencials.id),
      showCloseAll: '',
    };
    filterLoad({
      debounced: true,
      params: emptyObject(searchValues),
    });
    setSearch(emptyObject(searchValues));
    setPage(0);
  }

  function onInactive(actived) {
    const searchValues = {
      ...search,
      isActive: !actived && 1,
    };
    filterLoad({
      params: emptyObject(searchValues),
    });
    setIsActive(actived);
    setSearch(emptyObject(searchValues));
    setPage(0);
  }

  function onUpdate(values) {
    const updateValues = {
      id: Number(values.id),
      usersId: values.usersId && values.usersId.map((user) => user.id),
      name: values.name,
    };
    updateLoad({
      data: emptyObject(updateValues),
    });
    setView(false);
    setAlert(true);
  }

  function onRedirect(cashierId) {
    credencials.cashSession = cashierId;
    setCredencials(credencials);
    history.push('/home/caixas/detalhes');
  }

  function onTerminates() {
    const data = {
      id: Number(modalValues.id),
    };
    terminatesLoad({
      data,
      onCompleted: (res) => {
        setAlert(true);
        if (res) {
          setCloseCashier(false);
        }
      },
    });
  }

  function onAdjust(data) {
    adjustLoad({
      data,
    });
    setAdjustModal(false);
    setAlert(true);
  }

  function hadleModalCashierOpen(cashierId, isOpen, open) {
    if (credencials.cashSession === cashierId) {
      onRedirect(cashierId);
    } else {
      setModalCashierOpen({ open, cashierId, isOpen: isOpen === 1 });
    }
  }

  return (
    <>
      <Formik onSubmit={onSubmit} initialValues={initialState}>
        {({ values, submitForm, setFieldValue }) => (
          <Form onChange={() => submitForm()}>
            <UIContainer container direction="row">
              <Grid
                item
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                xs={12}
              >
                <UIFormTitle title="Filtrar caixas" />
                <UIFilter onClick={handleModalFilter} />
              </Grid>
              <Hidden smDown>
                <Grid item md={1}>
                  <Field
                    name="id"
                    label="ID"
                    placeholder="ID"
                    fullWidth
                    as={TextField}
                  />
                </Grid>
              </Hidden>

              <Grid item xs={6} md={3}>
                <Field
                  name="name"
                  label="Nome"
                  placeholder="Nome do caixa"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Hidden smDown>
                <Grid item md={2}>
                  <FormInputDate
                    name="startDate"
                    clearable
                    value={values.startDate}
                    label="Inicio vigência"
                    onChange={(value) => setFieldValue('startDate', value)}
                  />
                </Grid>
                <Grid item md={2}>
                  <FormInputDate
                    name="dueDate"
                    dateFormat="MM-DD-YYYY"
                    value={values.dueDate}
                    onChange={(value) => setFieldValue('dueDate', value, false)}
                    minDate={values.startDate}
                    clearable
                    label="Termino vigência"
                  />
                </Grid>
              </Hidden>

              <Grid item xs={6} md={3}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Ver caixas</FormLabel>
                  <FormGroup row>
                    <FormControlLabel
                      label="Abertos"
                      labelPlacement="start"
                      control={
                        <Checkbox
                          checked={values.isOpen}
                          onChange={(ev) =>
                            setFieldValue('isOpen', ev.target.checked)
                          }
                        />
                      }
                    />
                    <Hidden smDown>
                      <FormControlLabel
                        label="Meus caixas"
                        labelPlacement="start"
                        control={
                          <Checkbox
                            checked={values.userId}
                            onChange={(ev) =>
                              setFieldValue('userId', ev.target.checked)
                            }
                          />
                        }
                      />
                    </Hidden>
                  </FormGroup>
                </FormControl>
              </Grid>

              <Hidden smDown>
                <UIButtonSearch xs={1} />
              </Hidden>
            </UIContainer>

            <UIModalFilter
              open={filter}
              changeModal={handleModalFilter}
              submit={submitForm}
            >
              <Hidden mdUp>
                <Grid item xs={12}>
                  <Field
                    name="id"
                    label="ID"
                    placeholder="ID"
                    fullWidth
                    as={TextField}
                  />
                </Grid>
              </Hidden>
              <Grid item xs={12} md={12}>
                <CurrencyTextField
                  type="tel"
                  value={values.initialValue}
                  label="Valor inicial do caixa"
                  variant="standard"
                  decimalCharacter=","
                  digitGroupSeparator="."
                  currencySymbol="R$"
                  outputFormat="string"
                  fullWidth
                  onChange={(ev, value) => setFieldValue('initialValue', value)}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <CurrencyTextField
                  type="tel"
                  value={values.currentValue}
                  label="Valor atual do caixa"
                  variant="standard"
                  decimalCharacter=","
                  digitGroupSeparator="."
                  currencySymbol="R$"
                  outputFormat="string"
                  fullWidth
                  onChange={(ev, value) => setFieldValue('currentValue', value)}
                />
              </Grid>
              <Hidden mdUp>
                <Grid item xs={12}>
                  <FormInputDate
                    name="startDate"
                    value={values.startDate}
                    label="Inicio vigência"
                    onChange={(value) =>
                      setFieldValue('startDate', value, true)
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormInputDate
                    name="dueDate"
                    value={values.dueDate}
                    onChange={(value) => setFieldValue('dueDate', value, false)}
                    minDate={values.startDate}
                    clearable
                    fullWidth
                    label="Termino vigência"
                  />
                </Grid>
              </Hidden>
              <Grid item xs={12}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Ver caixas</FormLabel>
                  <FormGroup row>
                    <Hidden mdUp>
                      <FormControlLabel
                        label="Meus caixas"
                        labelPlacement="start"
                        control={
                          <Checkbox
                            checked={values.userId}
                            onChange={(ev) =>
                              setFieldValue('userId', ev.target.checked)
                            }
                          />
                        }
                      />
                    </Hidden>
                    <FormControlLabel
                      label="Somente inativos"
                      labelPlacement="start"
                      control={
                        <Checkbox
                          checked={values.showCloseAll}
                          onChange={(ev) =>
                            setFieldValue('showCloseAll', ev.target.checked)
                          }
                        />
                      }
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </UIModalFilter>
          </Form>
        )}
      </Formik>
      <UIContainer>
        <Grid
          item
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          xs={12}
        >
          <UIFormTitle title="Lista de caixas" />
          <FormControlLabel
            label={
              isActive ? 'Esconder caixas inativos' : 'Mostrar caixas inativos'
            }
            labelPlacement="start"
            control={
              <GreenSwitch
                checked={isActive}
                onChange={(ev) => onInactive(ev.target.checked)}
              />
            }
          />
        </Grid>
        <Grid item xs>
          {/* Tabela Desktop */}
          <Hidden smDown>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Nome</TableCell>
                    <TableCell>Início de vigência</TableCell>
                    <TableCell>Término de vigência</TableCell>
                    <TableCell>Valor do caixa</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterInfo.loading && <CircularProgress />}
                  {filterInfo.data &&
                    filterInfo.data
                      .slice(
                        page * rowsPerPage,
                        rowsPerPage === -1
                          ? undefined
                          : page * rowsPerPage + rowsPerPage,
                      )
                      .map((data) => (
                        <TableRow
                          className="cashier-search__table-row"
                          onDoubleClick={() => handleModalUpdate(data)}
                          onContextMenu={
                            !mobile
                              ? (ev) => handleClickRight(ev, data)
                              : undefined
                          }
                          style={{
                            cursor: 'context-menu',
                            backgroundColor:
                              (!Number(data.isActive) && '#EAEDED') ||
                              (!!Number(data.isActive) &&
                                Number(data.isOpen) === 1 &&
                                '#C6FFD1'),
                          }}
                          onClick={
                            mobile ? (ev) => handleClickLeft(ev, data) : undefined
                          }
                          key={data.id}
                        >
                          <TableCell component="th" scope="row">
                            {data.id}
                          </TableCell>
                          <TableCell>{data.name}</TableCell>
                          <TableCell>
                            {formattedDateTime(data.startDate)}
                          </TableCell>
                          <TableCell>
                            {formattedDateTime(data.dueDate) || 'Indefinido'}
                          </TableCell>
                          <TableCell>
                            {formattedCurrency(data.currentValue)}
                          </TableCell>
                          <TableCell>
                            {Number(data.isActive) === 0 ? (
                              <Chip
                                icon={<BlockIcon style={{ color: '#fff' }} />}
                                label="Inativo"
                                size="small"
                                style={{
                                  backgroundColor: '#D32F2F',
                                  color: '#fff',
                                  fontWeight: 'bold',
                                }}
                              />
                            ) : Number(data.isOpen) === 1 ? (
                              <Chip
                                icon={<LockOpenIcon style={{ color: '#fff' }} />}
                                label="Aberto"
                                size="small"
                                style={{
                                  backgroundColor: '#2E7D32',
                                  color: '#fff',
                                  fontWeight: 'bold',
                                }}
                              />
                            ) : (
                              <Chip
                                icon={<LockIcon style={{ color: '#fff' }} />}
                                label="Fechado"
                                size="small"
                                style={{
                                  backgroundColor: '#757575',
                                  color: '#fff',
                                  fontWeight: 'bold',
                                }}
                              />
                            )}
                          </TableCell>
                          <TableCell>
                            <Tooltip title="Mais detalhes">
                              <IconButton
                                onClick={() => handleModalUpdate(data)}
                                size="small"
                              >
                                <SearchIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              title={
                                data.isOpen === '1'
                                  ? 'Ir para fechamento de caixa'
                                  : 'Ir para abertura de caixa'
                              }
                            >
                              <span>
                                <IconButton
                                  onClick={() =>
                                    hadleModalCashierOpen(data.id, data.isOpen, true)
                                  }
                                  disabled={!Number(data.isActive)}
                                  size="small"
                                >
                                  <CallMadeIcon />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip title="Excluir caixa">
                              <span>
                                <IconButton
                                  disabled={!Number(data.isActive)}
                                  onClick={() => handleModalTerminates(data)}
                                  size="small"
                                >
                                  <PowerSettingsNewIcon />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip title="Ajuste Administrativo">
                              <span>
                                <IconButton
                                  disabled={!Number(data.isActive)}
                                  onClick={() => handleModalAdjust(data)}
                                  size="small"
                                >
                                  <SettingsIcon />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                  <Menu
                    keepMounted
                    open={clickRight.mouseY !== null}
                    onClose={handleCloseClickRight}
                    anchorReference="anchorPosition"
                    anchorPosition={
                      clickRight.mouseY !== null && clickRight.mouseX !== null
                        ? {
                            top: clickRight.mouseY,
                            left: clickRight.mouseX,
                          }
                        : undefined
                    }
                  >
                    <MenuItem onClick={() => handleModalUpdate(null, true)}>
                      Visualizar/Editar
                    </MenuItem>
                    <MenuItem onClick={() => handleModalAdjust(null, true)}>
                      Ajuste Administrativo
                    </MenuItem>
                    {Number(modalValues.isActive) === 1 && (
                      <MenuItem onClick={() => handleModalTerminates(null, true)}>
                        Excluir caixa
                      </MenuItem>
                    )}
                  </Menu>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={() => handleCloseClickLeft()}
                  >
                    <MenuItem onClick={() => handleModalUpdate(null, true)}>
                      Visualizar/Editar
                    </MenuItem>
                    {Number(modalValues.isActive) === 1 && (
                      <MenuItem onClick={() => handleModalAdjust(null, true)}>
                        Ajuste Administrativo
                      </MenuItem>
                    )}
                    {Number(modalValues.isActive) === 1 && (
                      <MenuItem onClick={() => handleModalTerminates(null, true)}>
                        Excluir caixa
                      </MenuItem>
                    )}
                  </Menu>
                  {filterInfo.error && (
                    <TableRow>
                      <TableCell colSpan={7}>Sem resultados encontrados</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <UITablePagination
                count={filterInfo.data ? filterInfo.data.length : 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </TableContainer>
          </Hidden>

          {/* Listagem em Cards Mobile */}
          <Hidden mdUp>
            <Box style={{ width: '100%' }}>
              {filterInfo.loading && (
                <CircularProgress style={{ margin: '16px auto', display: 'block' }} />
              )}
              {filterInfo.data &&
                filterInfo.data
                  .slice(
                    page * rowsPerPage,
                    rowsPerPage === -1
                      ? undefined
                      : page * rowsPerPage + rowsPerPage,
                  )
                  .map((data) => {
                    const isActiveCashier = Number(data.isActive) === 1;
                    const isOpenCashier = Number(data.isOpen) === 1;

                    let borderColor = '#2E7D32';
                    let cardBg = '#E8F5E9';
                    let statusText = 'Aberto';
                    let statusBg = '#2E7D32';
                    let StatusIcon = LockOpenIcon;

                    if (!isActiveCashier) {
                      borderColor = '#D32F2F';
                      cardBg = '#FFEBEE';
                      statusText = 'Inativo';
                      statusBg = '#D32F2F';
                      StatusIcon = BlockIcon;
                    } else if (!isOpenCashier) {
                      borderColor = '#757575';
                      cardBg = '#FFFFFF';
                      statusText = 'Fechado';
                      statusBg = '#757575';
                      StatusIcon = LockIcon;
                    }

                    return (
                      <Card
                        key={data.id}
                        variant="outlined"
                        style={{
                          marginBottom: 12,
                          borderLeft: `6px solid ${borderColor}`,
                          borderRadius: 8,
                          backgroundColor: cardBg,
                        }}
                      >
                        <CardContent style={{ paddingBottom: 8 }}>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mb={1}
                          >
                            <Typography
                              variant="subtitle1"
                              style={{ fontWeight: 'bold' }}
                            >
                              #{data.id} - {data.name}
                            </Typography>
                            <Chip
                              icon={<StatusIcon style={{ color: '#fff' }} />}
                              label={statusText}
                              size="small"
                              style={{
                                backgroundColor: statusBg,
                                color: '#fff',
                                fontWeight: 'bold',
                              }}
                            />
                          </Box>
                          <Divider style={{ margin: '8px 0' }} />
                          <Grid container spacing={1}>
                            <Grid item xs={6}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                display="block"
                              >
                                Início Vigência
                              </Typography>
                              <Typography variant="body2">
                                {formattedDateTime(data.startDate)}
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                display="block"
                              >
                                Término Vigência
                              </Typography>
                              <Typography variant="body2">
                                {formattedDateTime(data.dueDate) || 'Indefinido'}
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                display="block"
                              >
                                Valor do Caixa
                              </Typography>
                              <Typography
                                variant="body1"
                                style={{ fontWeight: 600, color: '#17497F' }}
                              >
                                {formattedCurrency(data.currentValue)}
                              </Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                        <Divider />
                        <CardActions
                          style={{ justifyContent: 'flex-end', padding: '4px 8px' }}
                        >
                          <Tooltip title="Mais detalhes">
                            <IconButton
                              size="small"
                              onClick={() => handleModalUpdate(data)}
                            >
                              <SearchIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip
                            title={
                              data.isOpen === '1'
                                ? 'Ir para fechamento de caixa'
                                : 'Ir para abertura de caixa'
                            }
                          >
                            <span>
                              <IconButton
                                size="small"
                                color="primary"
                                disabled={!isActiveCashier}
                                onClick={() =>
                                  hadleModalCashierOpen(data.id, data.isOpen, true)
                                }
                              >
                                <CallMadeIcon />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Excluir caixa">
                            <span>
                              <IconButton
                                size="small"
                                color="secondary"
                                disabled={!isActiveCashier}
                                onClick={() => handleModalTerminates(data)}
                              >
                                <PowerSettingsNewIcon />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Ajuste Administrativo">
                            <span>
                              <IconButton
                                size="small"
                                disabled={!isActiveCashier}
                                onClick={() => handleModalAdjust(data)}
                              >
                                <SettingsIcon />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </CardActions>
                      </Card>
                    );
                  })}
              {filterInfo.error && (
                <Typography
                  variant="body2"
                  color="textSecondary"
                  align="center"
                  style={{ padding: 16 }}
                >
                  Sem resultados encontrados
                </Typography>
              )}
              <UITablePagination
                count={filterInfo.data ? filterInfo.data.length : 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </Box>
          </Hidden>
        </Grid>
      </UIContainer>
      {modalValues && (
        <Dialog
          open={view}
          onClose={() => handleModalUpdate()}
          aria-labelledby="form-dialog-title"
        >
          <Formik
            enableReinitialize
            onSubmit={onUpdate}
            initialValues={modalValues}
          >
            {({
              values,
              touched,
              setFieldTouched,
              errors,
              setFieldValue,
              submitForm,
            }) => (
              <Form>
                <UIDialogTitle
                  id="form-dialog-title"
                  onClose={() => handleModalUpdate()}
                >
                  {modalValues.name}
                </UIDialogTitle>
                <DialogContent>
                  <Grid container direction="row" spacing={1}>
                    <Grid item xs={12} md={8}>
                      <Field
                        name="name"
                        label="Nome do caixa"
                        placeholder="Informe o nome do caixa"
                        fullWidth
                        disabled={!values.isActive}
                        className={!values.isActive && disabledTextField}
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <FormControlLabel
                        label={values.isOpen ? 'Caixa aberto' : 'Caixa fechado'}
                        labelPlacement="top"
                        control={<GreenSwitch checked={values.isOpen} />}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <CurrencyTextField
                        label="Valor inicial do caixa"
                        value={values.initialValue}
                        error={Boolean(errors.initialValue)}
                        helperText={errors.initialValue}
                        decimalCharacter=","
                        digitGroupSeparator="."
                        currencySymbol="R$"
                        outputFormat="string"
                        className={disabledTextField}
                        disabled
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <CurrencyTextField
                        type="tel"
                        value={values.currentValue}
                        label="Valor atual do caixa"
                        decimalCharacter=","
                        error={Boolean(errors.currentValue)}
                        helperText={errors.currentValue}
                        digitGroupSeparator="."
                        currencySymbol="R$"
                        outputFormat="string"
                        fullWidth
                        className={disabledTextField}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <FormControlLabel
                        value="top"
                        control={
                          <IconButton
                            disabled={!values.isActive}
                            onClick={() => handleModalTerminates(values)}
                          >
                            <PowerSettingsNewIcon size="small" />
                          </IconButton>
                        }
                        label="Excluir caixa"
                        labelPlacement="top"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormInputDateTime
                        name="startDate"
                        value={values.startDate}
                        helperText={errors.startDate}
                        error={Boolean(errors.startDate)}
                        disabled
                        className={disabledTextField}
                        label="Inicio vigência"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormInputDateTime
                        name="dueDate"
                        disabled
                        className={disabledTextField}
                        value={values.dueDate}
                        minDate={values.startDate}
                        label="Termino vigência"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        multiple
                        limitTags={4}
                        noOptionsText="Sem opções"
                        options={usersInfo.data !== null ? usersInfo.data : []}
                        getOptionLabel={(user) =>
                          `${user.username} - ${user.name}`
                        }
                        onBlur={() => setFieldTouched('usersId', true)}
                        onChange={(event, users) => {
                          setFieldValue('usersId', users);
                        }}
                        renderInput={(params) => (
                          <Field
                            {...params}
                            className="cashier-search__helperText"
                            name="usersId"
                            helperText={
                              touched.usersId &&
                              'Atenção: para retirar acesso de algum usuário ao caixa, vá para a aba Usuários e altere os caixas disponíveis para uso, diretamente no cadastro do mesmo.'
                            }
                            error={!touched}
                            variant="standard"
                            label="Adicionar operadores ao caixa"
                            placeholder="Adicionar mais"
                            component={TextField}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  {Number(values.isActive) === 1 && (
                    <Button
                      onClick={() => handleModalAdjust(null, false)}
                      color="primary"
                    >
                      Ajuste Administrativo
                    </Button>
                  )}
                  {!isEqualObject(values, modalValues) && (
                    <Button onClick={() => handleModalUpdate()} color="primary">
                      Cancelar
                    </Button>
                  )}
                  <Button
                    onClick={
                      isEqualObject(values, modalValues)
                        ? () => handleModalUpdate()
                        : () => submitForm()
                    }
                    color="primary"
                  >
                    {isEqualObject(values, modalValues) ? 'Fechar' : 'Salvar'}
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        </Dialog>
      )}

      <Dialog
        open={closeCashier}
        onClose={() => setCloseCashier(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <UIDialogTitle id="alert-dialog-title">
          Deseja encerrar vigencia do caixa {modalValues.name}
        </UIDialogTitle>
        <DialogActions>
          <Button onClick={() => setCloseCashier(false)} color="primary">
            Não
          </Button>
          <Button onClick={() => onTerminates()} color="primary" autoFocus>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <UIDialogConfirm
        open={alert}
        close={closeAlert}
        data={updateInfo.loading || updateInfo.data || updateInfo.error ? updateInfo :
          terminatesInfo.loading || terminatesInfo.data || terminatesInfo.error ? terminatesInfo :
            adjustInfo}
        setrequestinfo={closeAlert}
        messageSucess={
          (updateInfo.data && updateInfo.data.message) ||
          (terminatesInfo.data && terminatesInfo.data.message) ||
          (adjustInfo.data && adjustInfo.data.message) ||
          'Operação realizada com sucesso'
        }
        messageError={
          (updateInfo.error && 'Ocorreu um erro ao atualizar o caixa') ||
          (terminatesInfo.error && 'Ocorreu um erro ao encerrar o caixa') ||
          (adjustInfo.error && 'Ocorreu um erro ao realizar o ajuste') ||
          'Ocorreu um erro inesperado'
        }
      />
      <AdministrativeAdjustmentModal
        open={adjustModal}
        handleModal={handleModalAdjust}
        item={modalValues}
        type="CAIXA"
        onSubmit={onAdjust}
      />
    </>
  );
};

export default CashierSearch;
